import React, { useState } from 'react'
import Header from './Header'
import Footer from './Footer'
import call from '../img/icons/call.png';
import mail from '../img/icons/mail.png';
import map from '../img/icons/map.png';
import axios from 'axios';
export default function Contact() {

  const [formData, setFormData] = useState({
    name: '',
    company: '',
    email: '',
    phone: '',
    message: '',
  });

  const handleChange = (e) => {
    setFormData({...formData, [e.target.name]: e.target.value});
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post('https://tracsac.com.au/form.php', formData);
      alert('Message sent successfully!');
    } catch (error) {
      alert('Something went wrong.');
      console.error(error);
    }
  };

  return (
     <div>
         <Header />
          <div className="page_title contactpage">
  <div className="container">
    <div className="row">
      <div className="col-md-12">
        <h5 className="page_tittle activeColor text-center text-uppercase">
          Contact US
        </h5>
        {/* <div className="bread_crumb text-center text-lg-left">
          <a href="#">
            Home
            <i className="fa fa-angle-right pl-2" aria-hidden="true"></i>
          </a>
          <a href="#">
            Market Sectors
            <i className="fa fa-angle-right pl-2" aria-hidden="true"></i>
          </a>
          <a href="#">
            <span className="activeColor">Power and Energy</span>
          </a>
        </div> */}
      </div>
    </div>
  </div>
</div>


<div className="contact-page">
      <div className="container">
        <div className="row">

          {/* Left Column - Contact Info */}
          <div className="col-md-5 col-lg-4">
            <div className="block contact_address">
              <div className="title">
                <h4>Call Us</h4>
                <h1>or fill the form</h1>
              </div>

              {/* Phone */}
              <div
                className="media border-bottom contact-media wow fadeInUp animated"
                data-wow-delay="100ms"
                data-wow-duration="1500ms"
              >
                <img className="mr-3" src={call} alt="Call Icon" />
                <div className="media-body" style={{textAlign:'left'}}>
                  <h5 className="mt-0 mb-0"> +61 08 9353 4544</h5>
                  Don't hesitate to contact us!.
                </div>
              </div>

              {/* Email */}
              <div
                className="media border-bottom contact-media wow fadeInUp animated"
                data-wow-delay="200ms"
                data-wow-duration="1500ms"
              >
                <img className="mr-3" src={mail} alt="Mail Icon" />
                <div className="media-body" style={{textAlign:'left'}}>
                  <h5 className="mt-0 mb-0">Email Address:</h5>
                  tracs@tracs.com.au
                </div>
              </div>

              {/* Address */}
              <div
                className="media  contact-media wow fadeInUp animated"
                data-wow-delay="300ms"
                data-wow-duration="1500ms"
              >
                <img className="mr-3" src={map} alt="Map Icon" />
                <div className="media-body" style={{textAlign:'left'}}>
                  <h5 className="mt-0 mb-0">Address</h5>
                  3 Tipping Road
                  Kewdale, WA 6105.
                </div>
              </div>

              {/* Social Media */}
              {/* <div className="block mt-4 social-media d-flex justify-content-center">
                <a
                  className="ct-twitter d-flex justify-content-center align-items-center"
                  href="#"
                >
                  <i className="fab fa-twitter" aria-hidden="true"></i>
                </a>
                <a
                  className="ct-facebookr d-flex justify-content-center align-items-center"
                  href="#"
                >
                  <i className="fab fa-facebook-f" aria-hidden="true"></i>
                </a>
                <a
                  className="ct-instagramr d-flex justify-content-center align-items-center"
                  href="#"
                >
                  <i className="fab fa-linkedin-in" aria-hidden="true"></i>
                </a>
                <a
                  className="ct-skype d-flex justify-content-center align-items-center"
                  href="#"
                >
                  <i className="fab fa-skype" aria-hidden="true"></i>
                </a>
              </div> */}
            </div>
          </div>

          {/* Right Column - Contact Form */}
          <div className="col-md-7 col-lg-8">
            <div className="contact-feedback-block">
              <form onSubmit={handleSubmit}>
      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="form-control"
              placeholder="Name"
              required
            />
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-group">
            <input
              type="text"
              name="company"
              value={formData.company}
              onChange={handleChange}
              className="form-control"
              placeholder="Company"
            />
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="form-control"
              placeholder="Email Address"
              required
            />
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-group">
            <input
              type="text"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              className="form-control"
              placeholder="Phone"
            />
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-md-12">
          <div className="form-group">
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              className="form-control"
              rows="10"
              placeholder="How can we help?"
              required
            ></textarea>
          </div>
        </div>
      </div>

      <button type="submit" className="btn btn-primary">
        Send a Message
      </button>
    </form>
            </div>
          </div>

        </div>
      </div>
    </div>
 
         <Footer />
         
         </div>
  )
}
